/**
 * Cross-screen nav helpers for the planner / fuel-plan flow.
 *
 * Originally also tracked an `?expedited=1` URL param + `sessionStorage` mirror
 * for the expedited-shipping preview. That UX was removed (single delivery
 * cadence now), so this module is just path builders. The file name stays for
 * import-path stability; rename in a follow-up if it accumulates more helpers.
 */

export function plannerHref(): string {
  return "/my-training";
}

export function fuelPlanHref(id: string): string {
  return `/plan/${encodeURIComponent(id)}`;
}

/** Pending screen for an async generate request still building on the engine. */
export function planPendingHref(requestId: string): string {
  return `/plan/pending/${encodeURIComponent(requestId)}`;
}
